var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsText = function SvgSmsText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sms_text_svg2__a",
    x1: 16.4,
    x2: 186.9,
    y1: 217,
    y2: -1.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__b",
    x1: 0.7,
    x2: 171.1,
    y1: 204.7,
    y2: -13.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__c",
    x1: 25.3,
    x2: 195.7,
    y1: 223.9,
    y2: 5.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__d",
    x1: 10.7,
    x2: 181.2,
    y1: 212.5,
    y2: -5.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__e",
    x1: -3.8,
    x2: 166.6,
    y1: 201.1,
    y2: -17.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__f",
    x1: 11.6,
    x2: 182,
    y1: 213.2,
    y2: -5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__g",
    x1: 6.5,
    x2: 177,
    y1: 209.3,
    y2: -8.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__h",
    x1: -34.5,
    x2: 136,
    y1: 177.2,
    y2: -41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__i",
    x1: 41.4,
    x2: 211.9,
    y1: 236.5,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__j",
    x1: 50,
    x2: 220.5,
    y1: 243.2,
    y2: 25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__k",
    x1: -30.5,
    x2: 140,
    y1: 180.3,
    y2: -37.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_text_svg2__a",
    id: "sms_text_svg2__l",
    x1: -14.5,
    x2: 156,
    y1: 192.8,
    y2: -25.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M134 125.8c-.8 0-1.7 0-2.6-.1-1.6-.1-2.8-1.5-2.7-3.1s1.5-2.8 3.1-2.7c9 .7 10.6-2.7 10.9-6.2V70.3c0-.7-.3-2.7-1.9-4.3-1.8-1.8-4-1.8-4.6-1.8h-49c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h49c1.6 0 5.5.2 8.9 3.5 3.2 3.1 3.6 6.8 3.7 8.3v44c-.5 5.5-3.5 11.7-14.7 11.7Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7 137.6c-1.1 0-2.3-.3-3.3-.8-.6-.3-1.1-.7-1.5-1.1-1.3-1.3-2.1-3.1-2.1-5V70.2c0-6.6 5.6-11.9 12.5-11.9h9.2c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9h-9.2c-3.7 0-6.7 2.7-6.7 6.1v60.5c0 .3.2.6.3.8l.2.2c.4.2.9.1 1.4-.2l10.4-8.5c1.6-1.2 3.3-2.1 5.1-2.6 1.1-.3 2.2-.5 3.5-.5h39.4c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9H78.5c-.7 0-1.3 0-1.8.2-1.1.3-2.1.8-3 1.6l-10.4 8.6-.1.1c-1.3.9-2.8 1.4-4.4 1.4Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7 106.7c-4.8 0-8.8-3.9-8.8-8.8s3.9-8.8 8.8-8.8 8.8 3.9 8.8 8.8-3.9 8.8-8.8 8.8m0-11.7c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2 106.7c-4.8 0-8.8-3.9-8.8-8.8s3.9-8.8 8.8-8.8 8.8 3.9 8.8 8.8-3.9 8.8-8.8 8.8m0-11.7c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8 106.7c-4.8 0-8.8-3.9-8.8-8.8s3.9-8.8 8.8-8.8 8.8 3.9 8.8 8.8-3.9 8.8-8.8 8.8m0-11.7c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 200H54.7c-9.5 0-17.2-7.8-17.2-17.3V17.3C37.5 7.8 45.3 0 54.7 0h90.5c9.5 0 17.2 7.8 17.2 17.3v118.8c0 1.6-1.3 2.9-2.9 2.9s-2.9-1.3-2.9-2.9V17.3c0-6.3-5.1-11.4-11.3-11.4H54.7c-6.3 0-11.3 5.1-11.3 11.4v165.4c0 6.3 5.1 11.4 11.3 11.4h90.5c6.3 0 11.3-5.1 11.3-11.4v-33c0-1.6 1.3-2.9 2.9-2.9s2.9 1.3 2.9 2.9v33c0 9.5-7.7 17.3-17.2 17.3Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2 27.7h-17.1c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h17.1c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6 27.7h-88c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h88c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2 164.5H40.6c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h118.7c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9 188.1c-4.8 0-8.8-3.9-8.8-8.8s3.9-8.8 8.8-8.8 8.8 3.9 8.8 8.8-3.9 8.8-8.8 8.8m0-11.7c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8 16.2H90.1c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9h19.7c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9",
    style: {
      strokeWidth: 0,
      fill: "url(#sms_text_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8 16.2h-.6c-.2 0-.4 0-.5-.2-.2 0-.3-.2-.5-.3s-.3-.2-.4-.4l-.4-.4c-.1-.2-.2-.3-.3-.5 0-.2-.1-.4-.2-.5v-1.2c0-.2 0-.4.2-.5 0-.2.2-.3.3-.5s.2-.3.4-.4l.4-.4c.2-.1.3-.2.5-.3.2 0 .4-.1.5-.2h1.1c.2 0 .4 0 .5.2.2 0 .3.2.5.3s.3.2.4.4l.4.4c.1.2.2.3.3.5 0 .2.1.4.2.5v1.2c0 .2 0 .4-.2.5 0 .2-.2.3-.3.5s-.2.3-.4.4l-.4.4c-.2.1-.3.2-.5.3-.2 0-.4.1-.5.2h-.6Z",
    style: {
      fill: "url(#sms_text_svg2__l)",
      strokeWidth: 0
    }
  }));
};
export default SvgSmsText;